(() => {
  const getHeaderButton = () => document.querySelector('button.xb-wishlist-header-auto');

  const syncHeader = () => {
    const button = getHeaderButton();
    if (!button) return false;

    button.querySelector('.xb-wishlist-visible-label')?.remove();

    const countBubble = button.querySelector('.cart-count-bubble, [class*="quantity"]');
    const count = countBubble?.textContent.trim() || '';
    const label = count ? `收藏名單，${count} 項` : '收藏名單';

    button.setAttribute('aria-label', label);
    button.setAttribute('title', label);

    if (countBubble) countBubble.setAttribute('aria-hidden', 'true');

    let countText = button.querySelector('.xb-wishlist-count-a11y');
    if (count) {
      if (!countText) {
        countText = document.createElement('span');
        countText.className = 'visually-hidden xb-wishlist-count-a11y';
        button.append(countText);
      }
      countText.textContent = `${count} 項`;
    } else {
      countText?.remove();
    }

    return true;
  };

  const scheduleHeaderSync = () => {
    [0, 300, 1000].forEach((delay) => setTimeout(syncHeader, delay));
  };

  if (!syncHeader()) {
    const headerObserver = new MutationObserver(() => {
      if (syncHeader()) headerObserver.disconnect();
    });
    headerObserver.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => headerObserver.disconnect(), 5000);
  }

  document.querySelector('[data-xb-wishlist-menu]')?.addEventListener('click', () => {
    getHeaderButton()?.click();
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('.xb-wishlist-button, .xb-wishlist-button-collection__add')) {
      scheduleHeaderSync();
    }
  });
})();
